require('./classes/Application.js')
require('./classes/behaviors/Common.js')
require('./classes/behaviors/Arbre.js')
require('./classes/behaviors/Dossier.js')
require('./classes/behaviors/Eleve.js')
require('./classes/behaviors/Eleves.js')
require('./classes/behaviors/Groupe.js')
require('./classes/behaviors/GroupePublic.js')
require('./classes/behaviors/GroupePublicAuteur.js')
require('./classes/behaviors/GroupeSuivi.js')
require('./classes/behaviors/Niveau.js')
require('./classes/behaviors/Ressource.js')
require('./classes/behaviors/Sequence.js')
require('./classes/behaviors/SequenceGroupe.js')
require('./classes/behaviors/SequenceModele.js')
require('./classes/behaviors/Serie.js')
require('./classes/behaviors/SousSequence.js')
require('./classes/behaviors/Structure.js')
require('./classes/behaviors/Utilisateur.js')
require('./classes/common/Niveau.js')
require('./classes/common/Niveaux.js')
require('./classes/desklets/HomeInfo.js')
require('./classes/desklets/News.js')
require('./classes/desklets/Structure.js')
require('./classes/widgets/Dialog.js')
require('./classes/dialogs/CGU.js')
require('./classes/widgets/PropertyEditorDialog.js')
require('./classes/dialogs/ConfigurationStructure.js')
require('./classes/dialogs/Contact.js')
require('./classes/dialogs/Eleves.js')
require('./classes/dialogs/Preferences.js')
require('./classes/dialogs/Profil.js')
require('./classes/dialogs/ProfilItem.js')
require('./classes/dialogs/ProfilSelection.js')
require('./classes/dialogs/Register.js')
require('./classes/dialogs/SequenceEleves.js')
require('./classes/dialogs/SequencePartageDialog.js')
require('./classes/widgets/Page.js')
require('./classes/widgets/ScrollablePage.js')
require('./classes/pages/Accueil.js')
require('./classes/pages/Bilan.js')
require('./classes/widgets/Helper.js')
require('./classes/pages/Corbeille.js')
require('./classes/pages/GestionEleves.js')
require('./classes/pages/ImportOfficiel.js')
require('./classes/pages/ImportSynthese.js')
require('./classes/pages/ImportTableur.js')
require('./classes/pages/Sequence.js')
require('./classes/pages/TestSequence.js')
require('./classes/widgets/CollapsablePanel.js')
require('./classes/panels/Classes.js')
require('./classes/panels/Header.js')
require('./classes/widgets/FolderPanel.js')
require('./classes/panels/MesGroupes.js')
require('./classes/panels/MesRessources.js')
require('./classes/widgets/SequencesPanel.js')
require('./classes/panels/MesSequences.js')
require('./classes/panels/PressePapier.js')
require('./classes/panels/Ressources.js')
require('./classes/panels/RessourcesPartagees.js')
require('./classes/panels/SequencesCollegues.js')
require('./classes/theme/Appearance.js')
require('./classes/theme/Color.js')
require('./classes/theme/Decoration.js')
require('./classes/theme/Font.js')
require('./classes/theme/icons.js')
require('./classes/theme/Theme.js')
require('./classes/widgets/AlertDialog.js')
require('./classes/widgets/AskDialog.js')
require('./classes/widgets/AutoCompleteField.js')
require('./classes/widgets/ConfirmationDialog.js')
require('./classes/widgets/FileInput.js')
require('./classes/widgets/FormRendererSingle.js')
require('./classes/widgets/InputDialog.js')
require('./classes/widgets/ProgressDialog.js')
require('./classes/widgets/PropertyEditor.js')
require('./classes/widgets/splitpane/Blocker.js')
require('./classes/widgets/splitpane/HLayout.js')
require('./classes/widgets/splitpane/Pane.js')
require('./classes/widgets/splitpane/Slider.js')
require('./classes/widgets/splitpane/Splitter.js')
require('./classes/widgets/splitpane/VLayout.js')
require('./classes/widgets/TabView.js')
require('./classes/widgets/Toaster.js')
require('./classes/widgets/Tree.js')
require('./classes/widgets/TreeNode.js')
require('./classes/widgets/UploadButton.js')
